/* globals ConfettiGenerator */
'use strict';

import $ from 'jquery';
import DFClipboard from '@/js/modules/clipboard';
import { initOnboarding } from '@/js/modules/onboarding';
import { toggleDiscussionBoardDraft, toggleDiscussionPanel } from '@/js/application/messages';
import { onPageLoad } from '@/js/modules/page_load';
import '@/js/modules/jquery_modal_defaults';

onPageLoad(() => {
  $(function () {
    // TODO: Robert - clean up
    const isBoardPage = $('body').is('#board, #boards-preview, #boards');
    // 3D designs (fp_views#show) render the board_show_v2 designer layout too.
    if (isBoardPage || document.querySelector('.designer_view_v2')) {
      // board_show_v2 only, so pages without the flag never run this.
      const $designerViewV2 = $('.designer_view_v2');
      if ($designerViewV2.length) {
        // Fades the board image in once it loads (or fails); designer_view_v2.scss hides it until then.
        $designerViewV2.find('img.content-block__board-image').each(function () {
          const reveal = () => this.classList.add('content-block__board-image--loaded');
          if (this.complete) {
            reveal();
          } else {
            $(this).one('load error', reveal);
          }
        });

        // After an arrow click, keeps the arrows shown until the mouse moves and :hover applies.
        const ARROWS_VISIBLE_KEY = 'board-arrows-visible';
        $designerViewV2.on('click', '.pagination-link', function () {
          sessionStorage.setItem(ARROWS_VISIBLE_KEY, this.pathname);
        });
        const arrowTarget = sessionStorage.getItem(ARROWS_VISIBLE_KEY);
        sessionStorage.removeItem(ARROWS_VISIBLE_KEY);
        if (arrowTarget === window.location.pathname) {
          const $boards = $designerViewV2.find(
            '.content-block--board-image, .content-block--blank-board-image'
          );
          $boards.addClass('content-block--arrows-visible');
          $(document).one('pointermove', () =>
            $boards.removeClass('content-block--arrows-visible')
          );
        }
      }
    }

    if (isBoardPage) {
      // toggle item dropdown
      $('html').click(function (e) {
        const $target = $(e.target);
        if (!$target.is('.shoppable__menu *')) {
          $('.shoppable__menu').removeClass('shoppable__menu--active');
        }
      });

      $('.js-shoppable__menu-label').hover(
        function () {
          $(this).closest('.shoppable__menu-dropdown').css('overflow', 'visible');
        },
        function () {
          $(this).closest('.shoppable__menu-dropdown').css('overflow', 'hidden');
        }
      );

      $(document).on('click', '.js-shoppable__menu-trigger', function () {
        $('.shoppable__menu')
          .not($(this).closest('.shoppable__menu'))
          .removeClass('shoppable__menu--active');
        $(this).closest('.shoppable__menu').toggleClass('shoppable__menu--active');
      });

      function initOnboardingBoard(source) {
        // board_show_v2 moves preview/share into the right-hand sidebar card.
        const inSidebarV2 = !!document.querySelector('.board-content__sidebar');
        // Keep index-aligned with the copy in _onboarding.html.erb.
        const stepOptions = inSidebarV2
          ? [
              { element: '.board-content__preview-as-client', position: 'left' },
              { element: '.board-content__share-design', position: 'left' },
            ]
          : [
              { element: '.h-s-button--preview-as-client', position: 'left' },
              { element: '.dropdown-menu--share-designs', position: 'right' },
            ];

        let panelClosed = 0;
        let stepsSeen = 0;
        let finished = false;
        let ended = false;
        initOnboarding({
          stepOptions,
          onStart() {
            if (
              document
                .querySelector('.discussion-panel')
                ?.classList.contains('discussion-panel--active')
            ) {
              toggleDiscussionPanel(false, true);
              panelClosed = 1;
            }
          },
          onBeforeChange(targetEl) {
            const index = stepOptions.findIndex((option) => targetEl?.matches?.(option.element));
            stepsSeen = Math.max(stepsSeen, index + 1);
          },
          onFinish() {
            finished = true;
          },
          onComplete() {
            // intro.js fires both oncomplete and onexit on Finish; track the end once.
            if (!ended) {
              ended = true;
              window.mixpanel?.track('Design Board Walkthrough Ended', {
                source,
                completed: finished,
                steps_seen: stepsSeen,
              });
            }
            if (panelClosed === 1) {
              toggleDiscussionPanel(true);
            } else {
              toggleDiscussionPanel(false);
            }
            window.scrollTo(0, 0);
          },
        });
      }

      $(document).on(
        'click',
        '.dropdown-menu__link--walkthrough, .p-button--board-walkthrough',
        (e) => {
          e.preventDefault();
          const fromModal = e.currentTarget.classList.contains('p-button--board-walkthrough');
          initOnboardingBoard(fromModal ? 'first_design_modal' : 'menu');
        }
      );
    }

    $(document).on('ajax:success', '.request-questionnaire-form', (e) => {
      $.modal.close();
      $(e.target).trigger('reset');
    });

    $('.board-shoppables-list--sortable').length &&
      $('.board-shoppables-list--sortable').sortable({
        handle: '.shoppable__sort-handle',
        classes: {
          'ui-sortable-helper': 'shoppable--ui-sortable-helper',
        },
        update() {
          const orderedItems = $(this).children();
          const shoppables = orderedItems
            .map((index, el) => {
              const $el = $(el);
              return {
                order: index + 1,
                id: $el.data('board-shoppable-id'),
                kind: $el.data('kind'),
              };
            })
            .get();

          const boardId = parseInt($('meta[name=board-id]').attr('content'));
          $.post(`/boards/${boardId}/xhr_reorder`, { shoppables });
        },
      });

    // used for boards and fp_views
    $(document).on('blur', '.page-header--board-name', (e) => {
      const name = $(e.target).text();

      if ($('meta[name=board-id]').length) {
        const boardId = parseInt($('meta[name=board-id]').attr('content'));
        $.post(`/boards/${boardId}/xhr_update_name`, { name });
      } else {
        const fpViewId = parseInt($('meta[name=fp-view-id]').attr('content'));
        $.post(`/fp_views/${fpViewId}/xhr_update_name`, { name });
      }
    });

    $(document).on(
      'change',
      '.dropdown-menu__toggle--hide-design-from-client input[type="checkbox"]',
      (e) => {
        const published = e.target.checked;
        const el = e.target;

        if (document.body.id === 'boards') {
          const boardItem = el.closest('.boards-list__board');
          const boardData = boardItem.dataset;

          if (boardData.boardId) {
            const boardId = boardData.boardId;

            $.post('/boards/xhr_change_published_state', { board_ids: [boardId], published })
              .done(() => {
                if (published) {
                  const draftBadge = boardItem.querySelector('.boards-list__draft-badge');
                  if (draftBadge) {
                    draftBadge.remove();
                  }
                } else {
                  const badges = boardItem.querySelector('.boards-list__badges');
                  if (badges) {
                    const draftBadge = document.createElement('div');
                    draftBadge.className = 'boards-list__draft-badge';
                    draftBadge.textContent = 'DRAFT';
                    badges.appendChild(draftBadge);
                  }
                }
              })
              .fail(() => {
                console.error('There was an error updating the board.');
                el.checked = !published;
              });
          } else if (boardData.fpViewId) {
            const viewId = boardData.fpViewId;

            $.post('/fp_views/xhr_change_published_state', { fp_view_ids: [viewId], published })
              .done(() => {
                if (published) {
                  const draftBadge = boardItem.querySelector('.boards-list__draft-badge');
                  if (draftBadge) {
                    draftBadge.remove();
                  }
                } else {
                  const badges = boardItem.querySelector('.boards-list__badges');
                  if (badges) {
                    const draftBadge = document.createElement('div');
                    draftBadge.className = 'boards-list__draft-badge';
                    draftBadge.textContent = 'DRAFT';
                    badges.appendChild(draftBadge);
                  }
                }
              })
              .fail(() => {
                console.error('There was an error updating the fp view.');
                el.checked = !published;
              });
          }
        } else {
          if ($('meta[name=board-id]').length) {
            const boardId = parseInt($('meta[name=board-id]').attr('content'));

            $.post('/boards/xhr_change_published_state', { board_ids: [boardId], published })
              .done(() => {
                $('.board-draft-badge').toggleClass('hide');

                toggleDiscussionBoardDraft('board', boardId, published);
              })
              .fail(() => {
                console.error('There was an error updating the board.');
                el.checked = !published;
              });
          } else {
            const viewId = parseInt($('meta[name=fp-view-id]').attr('content'));

            $.post('/fp_views/xhr_change_published_state', { fp_view_ids: [viewId], published })
              .done(() => {
                const boardId = parseInt($('meta[name=fp-board-id]').attr('content'));

                $('.board-draft-badge').toggleClass('hide');

                toggleDiscussionBoardDraft('fp_board', boardId, published);
              })
              .fail(() => {
                console.error('There was an error updating the fp view.');
                el.checked = !published;
              });
          }
        }
      }
    );

    $(document).on(
      'click',
      `.p-button--modal-types-callout, .p-button--add-design, .h-s-button--add-design,
     .p-button--edit-board, .s-button--edit-board, .dropdown-menu__link--add-design`,
      (e) => {
        // show 2D/3D selection modal
        if ($('.modal--board-types').length) {
          $('.modal--board-types').modal();
          const $2dBoardLink = $('.board-types__type--2d');
          const path2dBoard = $(e.target).attr('data-path-2d-board');

          $2dBoardLink.removeAttr('data-method');
          $2dBoardLink.attr('href', path2dBoard);

          if (
            $(e.target).hasClass('p-button--add-design') ||
            $(e.target).hasClass('h-s-button--add-design') ||
            $(e.target).hasClass('dropdown-menu__link--add-design')
          ) {
            $2dBoardLink.attr('data-method', 'post');
          } else if ($(e.target).hasClass('p-button--modal-types-callout')) {
            $2dBoardLink.attr('data-method', 'get');
          }
          return false;
        }
      }
    );

    // The handler above retargets the 2D link, but some triggers open the modal directly with rel="modal:open"
    // (the design strip's "New Design"). Restore the rendered link on close so they don't inherit the last target.
    const $modal2dBoardLink = $('.board-types__type--2d');
    const default2dBoardHref = $modal2dBoardLink.attr('href');
    const default2dBoardMethod = $modal2dBoardLink.attr('data-method');
    $(document).on($.modal.AFTER_CLOSE, '.modal--board-types', () => {
      $modal2dBoardLink.attr({ href: default2dBoardHref, 'data-method': default2dBoardMethod });
    });

    $('.sortable-board-list').sortable({
      start: (e, ui) => {
        ui.placeholder.height(ui.item.height());
        ui.placeholder.css('visibility', 'visible');
      },
    });

    function populateEmbedBoardIframeTextarea() {
      const includeShoppables = $('input[name=include_shoppables]').prop('checked');
      if (includeShoppables) {
        $('.field--embed-board-iframe').val(
          $('input[name=embed_board_code_with_shoppables]').val()
        );
      } else {
        $('.field--embed-board-iframe').val(
          $('input[name=embed_board_code_without_shoppables]').val()
        );
      }
    }

    $(document).on($.modal.BEFORE_OPEN, '.modal--embed-board', (e) => {
      if ($('.field--embed-board-iframe').length) {
        populateEmbedBoardIframeTextarea();
      }

      $('.form-label-checkbox__checkbox').on('change', () => {
        populateEmbedBoardIframeTextarea();
      });
    });

    $(document).on('click', '.s-button--copy', () => {
      new DFClipboard('.field--embed-board-iframe').copy();
      $('.df-tooltip--embed-board .df-tooltip__text').fadeIn(500, () => {
        setTimeout(() => {
          $('.df-tooltip--embed-board .df-tooltip__text').fadeOut(500);
        }, 1000);
      });
    });

    if (document.getElementById('modal--first-time-publish')) {
      $(document).on($.modal.OPEN, '#modal--first-time-publish', () => {
        new ConfettiGenerator({
          target: 'confetti-canvas',
          max: 80,
          size: 1.2,
          animate: true,
          props: ['circle', 'square', 'triangle', 'line'],
          colors: [
            [255, 183, 77],
            [255, 138, 101],
            [255, 202, 40],
            [144, 202, 249],
          ],
          clock: 25,
          start_from_edge: true,
          respawn: true,
        }).render();
      });

      $('#modal--first-time-publish').modal();
    }
  });

  $(document).on('click', '.board-download-callout__close-button', (e) => {
    $('.board-download-callout').hide();
  });

  $(document).on('click', '.dropdown-menu__link--download-board-jpg', (e) => {
    $('.board-download-callout').show();
  });

  $(document).on('change', '.green-checkbox--toggle-drafts', (e) => {
    const showDrafts = $(e.currentTarget).prop('checked');
    const nearestPublishedUrl = e.currentTarget.dataset.nearestPublishedUrl;

    // On a draft details page, turning drafts OFF would hide the current design, so
    // move to the nearest published design instead of reloading the hidden draft.
    if (!showDrafts && nearestPublishedUrl) {
      window.location.href = nearestPublishedUrl;
      return;
    }

    const url = new URL(window.location);
    if (showDrafts) {
      url.searchParams.set('show_drafts', showDrafts);
    } else {
      url.searchParams.delete('show_drafts');
    }
    window.location.href = url;
  });
});
